import { http } from "api/http";

interface Data {
  name: string;
  color: string;
}

const getLabels = () => {
  return http.get("/admin/labels");
};

const getNewLabels = () => {
  return http.get("/admin/newLabels")
}

const createOrUpdateAdminLabelInProd = (data: Data) => {
  return http.post("admin/adminLabelInProd", data)
}

const createLabel = (data: Data) => {
  return http.post("/admin/labels", data);
};

const deleteLabel = (id: number) => {
  return http.delete(`/labels/${id}`);
};

const updateLabel = ({ id, data }: { id: number; data: Data }) => {
  http.put(`/labels/${id}`, data);
};

const getDocumentLabels = () => {
  return http.get("/admin/documentLabels");
};

const createDocumentLabel = (data: Data) => {
  return http.post("/admin/documentLabels", data);
};

const deleteDocumentLabel = (id: number) => {
  return http.delete(`admin/documentLabel/${id}`)
}

export {
  getLabels,
  createLabel,
  updateLabel,
  deleteLabel,
  getNewLabels,
  createOrUpdateAdminLabelInProd,
  getDocumentLabels,
  createDocumentLabel,
  deleteDocumentLabel
};
